$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('home-product-list')) {
    customElements.define(
      'home-product-list',
      class homeProductList extends HTMLElement {
        productDetailModalBigPictrueSwiper = null;
        productDetailModalSmallPictrueSwiper = null;
        shopMoneyFormat = null;
        productInventoryQuantity = null;
        productDetailModalCopy = null;
        constructor() {
          super();
        }

        connectedCallback() {
          const _this = this;

          this.init();
          this.initPopup();
          const hoverWidth = $(this).find('.hover-width');
          hoverWidth.on('mouseenter', function () {
            if ($(this).find('.hover_text').is(':visible')) {
              $(this).css('width', 'auto');
              const autoWidth = $(this).width();
              $(this).css('width', '32px');
              setTimeout(() => {
                $(this).css('width', `${autoWidth}px`);
              }, 50);
            }
          });
          hoverWidth.on('mouseout', function () {
            if ($(this).find('.hover_text').is(':visible')) {
              setTimeout(() => {
                if (!$(this).is(':hover')) {
                  $(this).css('width', '32px');
                }
              }, 50);
            }
          });

          this.shopMoneyFormat = window.shopMoneyFormat;

          // 获取所有data-product-handle的元素
          const $productHandles = $(this).find('[data-product-handle]');
          let $productDetailModal = $(this).find('.product-detail-modal');
          this.productDetailModalCopy = $productDetailModal.clone();

          $productHandles.on('click', function (event) {
            event.preventDefault();
            _this.openProductDetailModal(this);
          });

          const addCartButton = $(this).find('[data-first_variant_id]').find('[type="submit"]');
          addCartButton.on('click', function (event) {
            // 阻止默认事件
            event.preventDefault();
            // 获取index
            const index = $(_this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
            const dataFirstVariantId = $(_this).find('[data-first_variant_id]').eq(index).data('first_variant_id');
            const skuCount = $(_this).find('[data-first_variant_id]').eq(index).data('sku-count');
            if (skuCount > 1) {
              // 找到最外层的swiper-slide
              const $swiperSlide = $(this).closest('.swiper-slide');
              const $productHandle = $swiperSlide.find('[data-product-handle]');
              _this.openProductDetailModal($productHandle);
            } else {
              $(this).find('i').removeClass('hidden').addClass('flex');
              _this.addToCart(this, dataFirstVariantId, 1);
            }
          });
        }

        openProductDetailModal(element) {
          const _this = this;
          let $productDetailModal = $(this).find('.product-detail-modal');
          const productInventoryData = window.productInventoryData;
          // 禁用浏览器滚动
          window.litime.disableScroll();
          $productDetailModal = $(_this).find('.product-detail-modal');
          const $productDetailModalClose = $productDetailModal.find('.product-detail-modal_close');
          $productDetailModalClose.on('click', function () {
            $productDetailModal
              .addClass('hidden')
              .removeClass('flex')
              .replaceWith(_this.productDetailModalCopy.clone()); // 使用clone避免原始副本被修改
            _this.initPopup();

            _this.destroy();
          });
          const productId = $(element).data('product-id');
          _this.productInventoryQuantity = productInventoryData[productId];
          const productSellPoint1 = $(element).data('sell-point1');
          const productSellPoint2 = $(element).data('sell-point2');
          const productSellPoint3 = $(element).data('sell-point3');
          fetch(window.Shopify.routes.root + `products/${$(element).data('product-handle')}.js`)
            .then((response) => response.json())
            .then((product) => {
              // 右侧产品数据
              $productDetailModal.find('.product-detail-popup_title').text(product.title);
              $productDetailModal.find('.product-detail-popup_description').html(`<p>${product.description}</p>`);
              $productDetailModal
                .find('.product-detail-popup_price')
                .text(Shopify.formatMoney(product.variants[0].price, _this.shopMoneyFormat));
              console.log(product.variants[0].compare_at_price);
              if (product.variants[0].compare_at_price) {
                $productDetailModal
                  .find('.product-detail-popup_price_old')
                  .text(Shopify.formatMoney(product.variants[0].compare_at_price, _this.shopMoneyFormat));
                const discount = product.variants[0].compare_at_price - product.variants[0].price;
                if (discount > 0) {
                  const $productDetailPopupPriceDiscount = $(_this).find('.product-detail-popup_price_discount');
                  const $productDetailPopupPriceDiscountType = $(_this)
                    .find('.product-detail-popup_price_discount')
                    .data('type');
                  if ($productDetailPopupPriceDiscountType == 'quota') {
                    $productDetailPopupPriceDiscount.text(
                      window.Shopify.formatMoney(discount, _this.shopMoneyFormat) + ' OFF'
                    );
                  } else {
                    const discountPercent = ((discount / product.variants[0].compare_at_price) * 100).toFixed(2);
                    $productDetailPopupPriceDiscount.text('-' + discountPercent + ' %');
                  }
                } else {
                  $productDetailModal.find('.product-detail-popup_price_old').text('');
                  $productDetailModal.find('.product-detail-popup_price_discount').text('').css('display', 'none');
                }
              } else {
                $productDetailModal.find('.product-detail-popup_price_old').text('');
                $productDetailModal.find('.product-detail-popup_price_discount').text('').css('display', 'none');
              }

              // 创建变体选项
              const variantOptions = product.variants
                .map(
                  (variant) => `
                  <div class="product-variant-sku_item cursor-pointer text-[12px] leading-[12px] font-medium text-[#737373] border border-[#CDCDCD] rounded-[4px] px-[10px] py-[13px] line-clamp-1" data-product-variant-id="${variant.id}">
                    ${variant.title}
                  </div>
                `
                )
                .join('');

              $productDetailModal.find('.product-variant-sku_list').html(variantOptions);
              $productDetailModal.find('.product-variant-sku_item').first().addClass('product-variant_active');
              if (product.variants_count <= 1) {
                $productDetailModal.find('.product-variant-sku_choose_more').addClass('hidden');
                $productDetailModal.find('.product-variant-sku_list').addClass('hidden');
              }
              // 获取product-detail-popup下的input
              const $productDetailPopupInput = $productDetailModal.find('.global-number_input');
              // 获取第一个product-variant-sku_item的data-product-variant-id
              const productVariantId = $productDetailModal
                .find('.product-variant-sku_item')
                .first()
                .data('product-variant-id');
              _this.checkInventory(productVariantId, $productDetailModal, $productDetailPopupInput);

              const productVariants = $productDetailModal.find('.product-variant-sku_item');
              productVariants.on('click', function () {
                productVariants.removeClass('product-variant_active');
                _this.changeProductVariant(this);
                const index = productVariants.index(this);
                $productDetailModal
                  .find('.product-detail-popup_price')
                  .text(Shopify.formatMoney(product.variants[index].price, _this.shopMoneyFormat));
                if (product.variants[index].compare_at_price) {
                  $productDetailModal
                    .find('.product-detail-popup_price_old')
                    .text(Shopify.formatMoney(product.variants[index].compare_at_price, _this.shopMoneyFormat));
                  const discount = product.variants[index].compare_at_price - product.variants[index].price;
                  if (discount > 0) {
                    const $productDetailPopupPriceDiscount = $(_this).find('.product-detail-popup_price_discount');
                    const $productDetailPopupPriceDiscountType = $(_this)
                      .find('.product-detail-popup_price_discount')
                      .data('type');
                    if ($productDetailPopupPriceDiscountType == 'quota') {
                      $productDetailPopupPriceDiscount.text(
                        window.Shopify.formatMoney(
                          product.variants[index].compare_at_price - product.variants[index].price,
                          _this.shopMoneyFormat
                        ) + ' OFF'
                      );
                    } else {
                      const discountPercent = ((discount / product.variants[index].compare_at_price) * 100).toFixed(2);
                      $productDetailPopupPriceDiscount.text('-' + discountPercent + ' %');
                    }
                  } else {
                    $productDetailModal.find('.product-detail-popup_price_old').text('');
                    $productDetailModal.find('.product-detail-popup_price_discount').text('').css('display', 'none');
                  }
                } else {
                  $productDetailModal.find('.product-detail-popup_price_old').text('');
                  $productDetailModal.find('.product-detail-popup_price_discount').text('').css('display', 'none');
                }
                _this.checkInventory($(this).data('product-variant-id'), $productDetailModal, $productDetailPopupInput);
                _this.productDetailModalBigPictrueSwiper.slideTo(product.variants[index].featured_image.position - 1);
                _this.productDetailModalSmallPictrueSwiper.slideTo(product.variants[index].featured_image.position - 1);
              });

              // 左侧产品轮播图
              // 获取product-detail-modal_big_pictrue_swiper
              const $productDetailModalBigPictrueSwiper = $productDetailModal.find(
                '.product-detail-modal_big_pictrue_swiper'
              );
              // 根据product.images创建数量相同的元素
              product.images.forEach((image) => {
                // 获取slide并复制元素
                const $bigSlide = $productDetailModalBigPictrueSwiper.find('.swiper-slide').first().clone();
                $bigSlide.find('img').attr('src', image);
                $bigSlide.removeClass('swiper-slide-active');
                $productDetailModalBigPictrueSwiper.find('.swiper-wrapper').append($bigSlide);
              });
              $productDetailModalBigPictrueSwiper.find('.swiper-wrapper').children().first().remove();

              // 获取product-detail-modal_small_pictrue_swiper
              const $productDetailModalSmallPictrueSwiper = $productDetailModal.find(
                '.product-detail-modal_small_pictrue_swiper'
              );
              // 根据product.images创建数量相同的元素
              product.images.forEach((image) => {
                // 获取slide并复制元素
                const $smallSlide = $productDetailModalSmallPictrueSwiper.find('.swiper-slide').first().clone();
                $smallSlide.find('img').attr('src', image);
                $productDetailModalSmallPictrueSwiper.find('.swiper-wrapper').append($smallSlide);
              });
              $productDetailModalSmallPictrueSwiper.find('.swiper-wrapper').children().first().remove();
              _this.initProductDetailModalBigPictrueSwiper();
              _this.initProductDetailModalSmallPictrueSwiper();
              // 如果三个卖点都为空，则隐藏卖点
              if (!productSellPoint1 && !productSellPoint2 && !productSellPoint3) {
                $productDetailModal.find('.sell-point_list').css('opacity', 0).css('display', 'none');
              } else {
                $productDetailModal.find('.sell-point_list').css('opacity', 1);
              }
              // 设置产品卖点
              const updateSellPoint = (point, index, $modal) => {
                const $container = $modal.find(`.sell-point_item${index}`).parent();
                if (point) {
                  $container.removeClass('hidden').find(`.sell-point_item${index}`).text(point);
                } else {
                  $container.addClass('hidden');
                }
              };

              const sellPoints = [productSellPoint1, productSellPoint2, productSellPoint3];
              const hasPoints = sellPoints.some(Boolean);

              $productDetailModal
                .find('.sell-point_item1')
                .parent()
                .parent()
                .css('opacity', hasPoints ? 1 : 0);

              sellPoints.forEach((point, i) => {
                updateSellPoint(point, i + 1, $productDetailModal);
              });

              // 获取data-holiday-sale
              const holidaySale = $(element).data('holiday-sale');

              if (holidaySale) {
                const $holidaySaleIcon = $productDetailModal.find('.product-detail-popup_tags_icon');
                $holidaySaleIcon.removeClass('hidden').addClass('flex');
                $holidaySaleIcon.find('img').attr('src', holidaySale);
              }
              const saleTag = $(element).data('sale-tage');
              const saleTagBgColor = $(element).data('sale-tage-bg-color');
              const $saleTag = $productDetailModal.find('.product-detail-popup_tags_text');
              if (saleTag) {
                $saleTag.removeClass('hidden').addClass('flex');
                $saleTag.text(saleTag);
                $saleTag.css('background-color', saleTagBgColor);
              } else {
                $saleTag.addClass('hidden').removeClass('flex');
              }

              const learnMoreButton = $productDetailModal.find('.product-detail-popup_button_learn_more');
              if (learnMoreButton) {
                learnMoreButton.on('click', function () {
                  window.open(product.url, '_blank');
                });
              }

              $productDetailModal.removeClass('hidden').addClass('flex');
              // $productDetailModal.find('.sell-point_item1').parent().parent().css('opacity', 1);
            })
            .catch((error) => console.error(error));
        }

        init() {
          const $mySwiper = this.querySelector('.home-product-list_swiper');
          const $next = this.querySelector('.home-product-list_next');
          const $prev = this.querySelector('.home-product-list_prev');
          const $pagination = this.querySelector('.home-product-list_swiper-pagination');
          const $scrollbar = this.querySelector('.home-product-list_scrollbar');
          const swiper = new Swiper($mySwiper, {
            breakpoints: {
              1201: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 24,
              },
              577: {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 24,
              },
              0: {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 16,
              },
            },
            on: {
              slideChange: function () {
                if (this.isBeginning) {
                  $($prev).removeClass('flex').addClass('hidden');
                } else {
                  $($prev).removeClass('hidden').addClass('flex');
                }
                if (this.isEnd) {
                  $($next).addClass('hidden');
                } else {
                  $($next).removeClass('hidden');
                }
              },
            },
            navigation: {
              nextEl: $next,
              prevEl: $prev,
            },
            scrollbar: {
              el: $scrollbar,
              draggable: true,
            },
            pagination: {
              el: $pagination,
              bulletClass: 'home-product-list_bullet',
              bulletActiveClass: 'home-product-list_bullet_active',
            },
          });
        }

        initProductDetailModalBigPictrueSwiper() {
          const _this = this;
          const $productDetailModalBigPictrueSwiper = this.querySelector('.product-detail-modal_big_pictrue_swiper');
          this.productDetailModalBigPictrueSwiper = new Swiper($productDetailModalBigPictrueSwiper, {
            initialSlide: 2,
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: {},
            on: {
              slideChange: function () {
                if (_this.productDetailModalSmallPictrueSwiper) {
                  _this.productDetailModalSmallPictrueSwiper.slideTo(this.activeIndex);
                }
              },
            },
          });
        }

        initProductDetailModalSmallPictrueSwiper() {
          const _this = this;
          const $productDetailModalSmallPictrueSwiper = this.querySelector(
            '.product-detail-modal_small_pictrue_swiper'
          );
          const $next = this.querySelector('.small_pictrue_swiper_next');
          const $prev = this.querySelector('.small_pictrue_swiper_prev');
          this.productDetailModalSmallPictrueSwiper = new Swiper($productDetailModalSmallPictrueSwiper, {
            initialSlide: 2,
            slidesPerView: 5,
            centeredSlides: true,
            slideToClickedSlide: true,
            slidesPerGroup: 1,
            spaceBetween: 16,
            on: {
              slideChange: function () {
                if (_this.productDetailModalBigPictrueSwiper) {
                  _this.productDetailModalBigPictrueSwiper.slideTo(this.activeIndex);
                }

                if (this.isBeginning) {
                  $($prev).removeClass('flex').addClass('hidden');
                } else {
                  $($prev).removeClass('hidden').addClass('flex');
                }
                if (this.isEnd) {
                  $($next).addClass('hidden');
                } else {
                  $($next).removeClass('hidden');
                }
              },
            },
            navigation: {
              nextEl: $next,
              prevEl: $prev,
            },
          });
        }

        changeProductVariant(element) {
          $(element).addClass('product-variant_active');
          this.productVariantId = $(element).data('product-variant-id');
        }

        checkInventory(variantId, $modal, $input) {
          if (+this.productInventoryQuantity[variantId] <= 0) {
            $modal.find('.product-detail-popup_soldout').removeClass('hidden');
            $modal.find('.product-detail-popup_button').addClass('hidden');
            $input.attr('max', 1);
          } else {
            $modal.find('.product-detail-popup_soldout').addClass('hidden');
            $modal.find('.product-detail-popup_button').removeClass('hidden').addClass('flex');
            $input.attr('max', this.productInventoryQuantity[variantId]);
          }
          $input.val(1);
        }

        initPopup() {
          const _this = this;
          const submitButton = $(this.querySelector('.product-detail-popup_form_wrapper')).find(
            'button[type="submit"]'
          );
          this.productDetailModalWrapperCopy = $(this).find('.product-detail-modal_wrapper').clone();
          submitButton.on('click', function (event) {
            event.preventDefault();
            const productVariantId = $(_this.querySelector('.product-variant_active')).data('product-variant-id');
            // 获取type为number的input
            const inputNumber = $(_this.querySelector('.global-number_input'));
            const quantity = inputNumber.val();
            $(this).find('i').removeClass('hidden').addClass('flex');
            _this.addToCart(this, productVariantId, quantity);
          });
        }

        async addToCart(event, variantId, quantity = 1) {
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: parseInt(variantId),
                    quantity: quantity,
                  },
                ],
                sections: 'cart-drawer,cart-icon-bubble',
              }),
            });

            if (response.status == 200) {
              $(event).find('i').addClass('hidden').removeClass('flex');
              const cartContent = await response.json();
              await updateCartComponents(cartContent);

              // 打开购物车抽屉
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.open();
              }
            } else {
              const errorData = await response.json();
              console.error('Add Cart error:', errorData);
              $(event).find('i').addClass('hidden').removeClass('flex');
              window.litime.showToast('error', errorData.description || 'Failed to Add to Cart');
            }
          } catch (error) {
            console.error('Error:', error);
            $(event).find('i').addClass('hidden').removeClass('flex');
            window.litime.showToast('error', errorData.description || 'Failed to Add to Cart');
          }
        }

        destroy() {
          // 恢复浏览器滚动
          window.litime.enableScroll();
          if (this.productDetailModalSmallPictrueSwiper) {
            this.productDetailModalSmallPictrueSwiper.destroy();
          }
          if (this.productDetailModalBigPictrueSwiper) {
            this.productDetailModalBigPictrueSwiper.destroy();
          }
        }
      }
    );
  }
});
